import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Audio3 = () => {
  return (
    <div>
      <Navbar />
        <div className="text-black ml-20 mt-5">
          <Link to="/mainaudiopage">
            <button className="flex gap-1 px-4 py-2 rounded-xl w-fit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
              Back
            </button>
          </Link>
        </div>
          <h1 className="text-[#314C1C] text-3xl text-center font-bold pt-5 ">
          SHAPING YOUR SAFESPOT
          </h1>
        <div className="lg:items-center justify-center mx-20 my-5 px-10 py-7 bg-[#DCAE96] mb-10 ">
            <div className="w-full md:grid md:justify-center md:items-center md:place-content-center">     
              <Link to=""
              >
                <div>
                <img
                  src="https://res.cloudinary.com/djltdw88d/image/upload/v1700580259/thrive-audio-1-4/nrtyh9vxmdyx2dfr8416.png"
                  alt="audio-img"
                  className="w-full md:w-[400px] md:h-[250px] rounded-md text-center object-cover"
                />
                <audio controls src="https://res.cloudinary.com/djltdw88d/video/upload/v1701287327/audio1-4%20audios/wpbhyd6zmroaddmmtlhe.mp3" className="w-full md:w-[400px]">
              </audio>
                </div>
              </Link>
              
              <div className="flex flex-col lg:flex-row lg:gap-16 gap-4 px-4 py-5 justify-center">
                <Link
                  to="https://res.cloudinary.com/djltdw88d/video/upload/v1701287327/audio1-4%20audios/wpbhyd6zmroaddmmtlhe.mp3">
                  <button
                    className="flex justify-center items-center text-[whitesmoke] font-medium bg-[#314C1C] p-3 rounded-md border-none">
                    DOWNLOAD
                  </button>
                </Link>
              </div>
            </div>
        
          <section className="md:mt-5 content-center justify-center items-center place-content-center px-5">
            <div className="content-center justify-center items-center place-content-center">
              <p className="text-[#314C1C] text-md text-justify text-[20px]">
              In the tapestry of our lives, amidst the ebb and flow of
              experiences, exists a haven that transcends the chaos of the
              world—a safe spot where tranquillity reigns supreme. This
              sanctuary, though intangible, holds the power to envelop us in a
              cocoon of comfort, shielding us from the stresses and
              uncertainties of daily life. Shaping this safe spot is a journey
              of self-care and intention, a pathway to cultivating emotional
              well-being and fostering resilience. Creating a safe spot is akin
              to crafting a mental refuge, a place within our consciousness
              where we can retreat when the world becomes overwhelming.
            </p>
            </div>
          </section>
        </div>

      <Footer />
    </div>
  );
};

export default Audio3;
